import React, { createContext, useContext, useState, useEffect } from 'react';

const NotifContext = createContext();
const STORAGE_KEY = 'ryzenos_notifs';

function loadNotifs() {
  try {
    const raw = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    // Normalize shape: pushNotif() writes {id, msg, time, read}; UI expects {id, text, time, read, type}
    return raw.map(n => ({
      id: n.id,
      text: n.text || n.msg || '',
      time: n.time || '',
      read: n.read || false,
      type: n.type || 'activity',
    }));
  } catch { return []; }
}

export function NotifProvider({ children }) {
  const [notifs, setNotifs] = useState(loadNotifs);

  // Poll localStorage every 2s so notifications pushed from anywhere (Team, Leads, Finance, Projects, Employee portal) show up live
  useEffect(() => {
    const interval = setInterval(() => {
      setNotifs(prev => {
        const fresh = loadNotifs();
        // Only update if something actually changed, to avoid unnecessary re-renders
        if (fresh.length !== prev.length || JSON.stringify(fresh) !== JSON.stringify(prev)) {
          return fresh;
        }
        return prev;
      });
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  const persist = (next) => {
    setNotifs(next);
    try {
      // Write back in the same shape pushNotif() uses, preserving read state
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next.map(n => ({ id:n.id, msg:n.text, time:n.time, read:n.read, type:n.type }))));
    } catch {}
  };

  const markRead = (id) => persist(notifs.map(x => x.id===id ? {...x,read:true} : x));
  const markAll  = ()   => persist(notifs.map(x => ({...x,read:true})));
  const unread   = notifs.filter(n => !n.read).length;

  return <NotifContext.Provider value={{ notifs, markRead, markAll, unread }}>{children}</NotifContext.Provider>;
}

export const useNotif = () => useContext(NotifContext);
